import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import {
  accept as actionAccept,
  decline as actionDecline
} from '../../../actions/projects';
//import {Modal as BaseModal, Button} from 'react-bootstrap';
import { default as BaseModal } from 'react-bootstrap/lib/Modal';

class ShareDialog extends React.PureComponent {
  constructor(...args) {
    super(...args);
    this.handleInput = this.handleInput.bind(this);

    this.state = {
      value: ''
    };
  }

  handleInput(e) {
    this.setState({ value: e.target.value });
  }

  render() {
    const { show, close, pending } = this.props;
    if (!pending || pending.length === 0) {
      return (
        <BaseModal show={show} onHide={close}>
          <BaseModal.Body>
            <div className="loader-task">
              <span className="fa fa-spinner fa-spin" />
              {I18n.t('other.loading')}
              ...
            </div>
          </BaseModal.Body>
        </BaseModal>
      );
    }

    const project = pending[0];

    return (
      <BaseModal show={show} onHide={close}>
        <BaseModal.Header closeButton>
          <BaseModal.Title>
            {' '}
            {I18n.t('learnProcess.ace.package')}{' '}
          </BaseModal.Title>
        </BaseModal.Header>
        <BaseModal.Body>
          {I18n.t('learnProcess.ace.userSharedProgram', {
            user: project.from,
            programName: project.name
          })}
          <div style={{ marginTop: '10px' }}>
            <button
              className="btn btn-danger"
              onClick={e => {
                e.preventDefault();
                this.props.decline(project._id);
                close();
              }}
            >
              {I18n.t('learnProcess.ace.reject')}
            </button>
            <button
              className="btn btn-success pull-right"
              onClick={e => {
                e.preventDefault();
                this.props.accept(project._id);
                close();
              }}
            >
              {I18n.t('learnProcess.ace.save')}
            </button>
          </div>
        </BaseModal.Body>
      </BaseModal>
    );
  }
}

function mapStateToProps(state) {
  const { pending } = state.projects;

  return {
    pending
  };
}

const mapDispatchToProps = dispatch => ({
  accept: id => dispatch(actionAccept(id)),
  decline: id => dispatch(actionDecline(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShareDialog);
